import { FinalTechMapTable } from './FinalTechMapTable.main';

export { FinalTechMapTable };
